/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * Risk Modelling Platform API
 * The API for the risk modelling platform
 * OpenAPI spec version: 1.0
 */

/**
 * Referred to as "Data Source" in frontend.
 */
export type AppWeatherModelType =
  (typeof AppWeatherModelType)[keyof typeof AppWeatherModelType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AppWeatherModelType = {
  barpa: "barpa",
  barra: "barra",
  barra2: "barra2",
  forecast: "forecast",
  observations: "observations",
} as const;
